'use strict';

var novicell = novicell || {};


novicell.newsCarousel = novicell.newsCarousel || new function () {
    const portals = document.querySelector('.portals-toggle');
    this.init = function () {
        if (!portals) return null;
        new Vue({
            el: portals,
            data: {
                checked: false
            },
            methods: {
                onChange: function () {

                }
            }
        })
    };
}();
